<template>
  <div v-if="active" v-show="!loading" class="modal is-active">
    <div class="modal-background"></div>
    <aside class="modal-card">
      <header v-if="!loading" class="title">
        <button v-if="isFablabsContest"
                aria-label="To close modal"
                class="close cursor-pointer"
                @click="close(false)">
          <i class="fal fa-times"/>
        </button>
        <h2 qa="tell-us-title">
          {{ surveyTitle }}
        </h2>
      </header>
      <survey @close="next"
              @changeTitle="changeTitle"
              @doneLoading="doneLoading"
              @questionUserTypeSet="questionUserTypeSet"
              :grouping="grouping"
              :signUpForm="true"/>
    </aside>
  </div>
</template>

<script>
import componentState from '@/mixins/component-state'
import { getEnvName } from '@/mixins/util'
import i18n from '@/i18n'
import userTypes from '@/mixins/user-types'

const Survey = () =>
  import('@/components/Modals/SignupSurvey/Survey').then(({ Survey }) =>
    Survey(getEnvName()))

export default {
  components: {
    Survey
  },
  props: {
    grouping: {
      type: Number
    }
  },
  mixins: [componentState, userTypes],
  data: function () {
    return {
      active: false,
      loading: true,
      fablabsTitle: 'Anmeldeformular Makerspace-Challenge',
      customQuestionUserType: ''
    }
  },
  mounted: function () {
  },
  computed: {
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    platform: function () {
      return this.appName
    },
    isJudgingRegistration: function () {
      return this.customQuestionUserType === this.UserTypeJudge
    },
    surveyTitle: function () {
      switch (this.platform) {
        case 'neweng':
          return 'How did you hear about us?'
        case 'ysc':
          return this.isJudgingRegistration ? i18n.t('signupSurvey.yscJudgeRegistrationTitle') : i18n.t('signupSurvey.yscTitle')
        case 'ohiosci':
          return this.isJudgingRegistration ? i18n.t('signupSurvey.oasJudgeRegistrationTitle') : i18n.t('surveyMake.title')
        case 'girls-and-steam':
          return i18n.t('signupSurvey.gasTitle')
        case 'heise':
          return this.isFablabsContest ? this.fablabsTitle : i18n.t('surveyMake.title')
        default:
          return i18n.t('surveyMake.title')
      }
    },
    userInformationMissing: function () {
      return this.$store.getters.modalIsVisible('survey')
    },
    isFablabsContest: function () {
      return this.$route.name === 'fablabsthankyou' || this.$store.getters.modalData('survey')?.type === 'fablabs'
    }
  },
  watch: {
    active: function (active) {
      if (active) {
        this._callback('lockScrolling', false)
      } else {
        this._callback('unlockScrolling', true)
      }
    },
    userInformationMissing: function (active) {
      this.active = active
    }
  },
  methods: {
    doneLoading: function () {
      this.loading = false
    },
    questionUserTypeSet: function (newQuestionUserType) {
      this.customQuestionUserType = newQuestionUserType
    },
    next: function () {
      if (this.userInformationMissing) {
        this.$store.dispatch('hideSignupSurvey')
      }
      this.active = false
      this.$emit('modalDone', true, true)
    },
    showModal: function () {
      this.active = true
    },
    changeTitle: function () {
      this.fablabsTitle = 'Vielen Dank!'
    },
    close: function () {
      this.active = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

  $border-color: #DCDCDC;
  $modal-body-color: #F2F2F2;
  $error-message-height: 24px;
  $close-icon-color: #1A051D;

  .modal-card {
    background: $modal-body-color;
    text-align: center;

    // HEADER
    .title {
      border-bottom: 1px solid $border-color;
      padding: 1.3rem 0;
      h2 {
        font-family: $primary-font;
        font-weight: $primary-font-weight;
        font-size: 1.5rem;
      }
    }
  }

  .close {
    top: 0.4rem;
    right: 1rem;
    position: absolute;
    font-size: 1.5rem;
    color:  $close-icon-color;
    border: none;
    padding: 0;
    background: transparent;
    &:hover {
       color: $link-hover;
     }
  }

</style>
